import NotFound404Img from '@/assets/images/not-found-img.png';

export default function NotFoundPage() {
    return (
        <div className='container py-10'>
            <div className='w-1/2 max-w-[400px] mx-auto'>
                <div className='w-full h-full flex flex-col justify-center items-center'>
                    <img src={NotFound404Img} alt='Page not found' />
                </div>
            </div>
        </div>
    );
}
